const {jQuery: $} = window;

export default class RotatingTabs {

    #theme;

    /**
     * @param {Theme} theme
     */
    constructor(theme) {
        this.#theme = theme;
    }

    events() {
        const me = this;

        function checkSlider() {
            if ($("#mobile-indicator").css("visibility") == "visible" ) {
                $(".tabbed_section_two").cycle("pause");
            } else if ($("#mobile-indicator").css("visibility") == "hidden" ) {
                $(".tabbed_section_two").cycle("resume");
            }
        }

        // run test on initial page load
        checkSlider();

        // run test on resize of the window
        $(window).resize(checkSlider);

        $('.rotating-tabs .tabbed_section .single_tab__tab').on('click', function () {
            const num = $(this).attr('data-tab');
            const $parent = $(this).parents('.builder-layout');
            const $tabs = $parent.find('.tabbed_section');
            const $content = $parent.find('.tabbed_section_two');
            const $tab = $(this).parents('.single_tab_overtab');

            $content.find('.single_tab__content').removeClass('active').addClass('off');
            $content.find('[data-tab="' + num + '"]').addClass('active').removeClass('off');

            $tabs.find('.single_tab_overtab').removeClass('active').addClass('off');
            $tab.addClass('active').removeClass('off');

            $parent.find('.tabbed_section__mobile').html($tab.prop('outerHTML'));
            $parent.find('.tabbed_section__tabs').removeClass('tabbed_section__tabs--open');
        });

        $('.rotating-tabs .tabbed_section__mobile').on('click', function () {
            const $parent = $('.tabbed_section');
            console.log("clicked!");
            $parent.find('.tabbed_section__tabs').toggleClass("tabbed_section__tabs--open");
            $parent.find('.tabbed_section__mobile').toggleClass("tabbed_section__mobile--open");
        });

        $('.rotating-tabs .tabbed_section').each(function (i, el) {
            const $tab = $(el).find('.single_tab_overtab:first-child');
            $(el).find('.tabbed_section__mobile').html($tab.prop('outerHTML'));
            $(el).attr("data-height", $(el).find('.tabbed_section_two').css("max-height"));
        });
    }
}
